import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e9a7c394"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "featured" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "box_list" }
const _hoisted_4 = { class: "text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_typography_title = _resolveComponent("a-typography-title")!
  const _component_a_image = _resolveComponent("a-image")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_AndroidOutlined = _resolveComponent("AndroidOutlined")!
  const _component_a_space = _resolveComponent("a-space")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_a_typography_title, { level: 1 }, {
        default: _withCtx(() => [
          _createTextVNode(" 数字人功能演示 ")
        ]),
        _: 1 /* STABLE */
      }),
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.expand.list, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            ref_for: true,
            ref: "item",
            class: _normalizeClass(["item", [`i_${index+1}`,index+1===$data.expand.active?'active':'']])
          }, [
            _createVNode(_component_a_typography_title, { level: 5 }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(item.title), 1 /* TEXT */)
              ]),
              _: 2 /* DYNAMIC */
            }, 1024 /* DYNAMIC_SLOTS */),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.text, (v) => {
              return (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createVNode(_component_a_image, {
                  alt: "",
                  src: v.image
                }, null, 8 /* PROPS */, ["src"]),
                _createCommentVNode(" {{ v.text }} ")
              ]))
            }), 256 /* UNKEYED_FRAGMENT */))
          ], 2 /* CLASS */))
        }), 256 /* UNKEYED_FRAGMENT */))
      ]),
      _createVNode(_component_a_space, {
        size: _ctx.$Store.Public().isGridMatch('>=',_ctx.$Enum.GridEnum.XL)?'large':'small'
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_button, {
            type: "link",
            class: "button_n_3",
            onClick: _cache[0] || (_cache[0] = ($event: any) => ($options.clickToAidigitalHuman())),
            style: {"width":"135px !important"}
          }, {
            default: _withCtx(() => [
              _createTextVNode(" 免费试用(SaaS) ")
            ]),
            _: 1 /* STABLE */
          }),
          _createVNode(_component_a_button, {
            type: "link",
            class: "button_n_3",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$FN.JumpDownloadApk())),
            style: {"width":"135px !important"}
          }, {
            default: _withCtx(() => [
              _createTextVNode(" 下载客户端 "),
              _createVNode(_component_AndroidOutlined)
            ]),
            _: 1 /* STABLE */
          }),
          _createVNode(_component_a_button, {
            class: "button_n_2",
            type: "link",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$Store.Page().openModal('modalFormCollection','productAidigitalHuman')))
          }, {
            default: _withCtx(() => [
              _createTextVNode(" 联系我们 ")
            ]),
            _: 1 /* STABLE */
          })
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["size"])
    ])
  ]))
}